<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: user.slug }}"
    :showCloseButton="true"
  >

    <div
      slot="content"
      class="p-3"
    >
      <div v-if="!processing">
        <form
          class="mt-3"
          v-on:submit.prevent="onSubmit"
        >

          <div class="form-group animate__animated animate__fadeIn">

            <div class="form-group p-3 bg-light rounded border shadow-sm">

              <label>Label</label>
              <input
                placeholder="e.g. Add a drink"
                v-model="crossSellGroupLabel"
                type="text"
                maxlength="128"
                class="form-control"
              />

              <div class="my-4 bg-white p-3">
                <label class="d-block text-center">Select items to add to group</label>
                <hr>
                <div class="items-container">
                  <draggable v-model="items">
                    <div
                      class="py-3 px-1 border-bottom"
                      v-for="(option,index) in items"
                      :key="index"
                    >
                      <label class="container-label">
                        <span class="text-muted w-50">{{ option.name }}</span>
                        <input
                          v-model="option.selected"
                          type="checkbox"
                        />
                      </label>
                    </div>
                  </draggable>
                </div>
                <div
                  v-if="!items"
                  class="text-info small text-center p-3 rounded border border-info d-flex align-items-center justify-content-center"
                > Add some menu items to get started</div>

              </div>

              <div
                v-if="groupErrorMessage"
                class="text-danger small text-center p-3 rounded border border-danger mb-3 d-flex align-items-center justify-content-center"
              >{{ groupErrorMessage }}</div>
              <a
                href="#"
                class="d-inline-block color-1 small font-weight-bold animate__animated animate__fadeIn"
                v-on:click.prevent="addGroup()"
              >
                Add Group
              </a>
            </div>
            <div>
              <draggable v-model="crossSellGroups">
                <div
                  class="py-3 px-1 my-3  bg-light rounded p-3 small"
                  v-for="(group,i) in crossSellGroups"
                  :key="i"
                >

                  <label>{{ group.label}}</label>
                  <div
                    class="py-3 px-1 border-bottom text-muted"
                    v-for="(item,i) in group.items"
                    :key="i"
                  >
                    <span class="ml-2">{{ item.name }}</span>
                  </div>
                  <div class="mt-4"> <a
                      href=""
                      class="ml-3 small color-1"
                      v-on:click.prevent="removeGroup(group)"
                    >Remove</a></div>
                </div>
              </draggable>
            </div>
          </div>
          <formSubmit v-if="!processing" />
        </form>
      </div>

      <div
        v-if="processing"
        class="text-center my-5"
      >
        <formLoader
          class="mb-2"
          :width="30"
        ></formLoader>

      </div>
    </div>
  </modal>
</template>

  <style lang="scss" scoped>
.items-container {
  height: 15rem;
  overflow-y: scroll;
}
</style>

  <script>
import accountingMixin from "../../../mixins/accountingMixin";
import formLoader from "../../form/FormLoader";
import formSubmit from "../../form/FormSubmit";
import modal from "../../shared/Modal";
import draggable from "vuedraggable";

export default {
  mounted() {
    let _self = this;
    _.forEach(this.rawMenu.categories, function (cValue, cKey) {
      _.forEach(cValue.items, function (iValue, iKey) {
        iValue.selected = false;
        _self.items.push(iValue);
      });
    });
    this.crossSellGroups = _.cloneDeep(this.rawMenu.cross_sell_groups);
  },
  data() {
    return {
      processing: false,
      uploadPercentage: 0,
      items: [],
      crossSellGroups: [],
      crossSellGroupLabel: null,
      groupErrorMessage: null,
    };
  },
  methods: {
    onSubmit: function () {
      this.processing = true;
      let formData = new FormData();

      formData.append(
        "cross_sell_groups",
        JSON.stringify(this.crossSellGroups)
      );
      formData.append("_method", "PATCH");

      axios
        .post(this.crossSellUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        })
        .then(
          (response) => {
            this.processing = false;
            this.error = null;
            if (response.data) {
              this.refreshMenu(this.$route.params.userSlug);
              this.closeModals();
            }
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },

    addGroup: function () {
      this.groupErrorMessage = "";
      let selectedOptions = _.filter(this.items, function (o) {
        return o.selected === true;
      });

      if (!this.crossSellGroupLabel) {
        this.groupErrorMessage = "Add a label for the group";
        return;
      }

      if (!selectedOptions.length) {
        this.groupErrorMessage = "Select some menu items";
        return;
      }

      this.crossSellGroups.push({
        label: this.crossSellGroupLabel,
        items: selectedOptions,
      });

      this.crossSellGroupLabel = null;

      _.forEach(this.items, function (cValue, cKey) {
        cValue.selected = 0;
      });
    },
    removeGroup: function (group) {
      this.crossSellGroups.splice(this.crossSellGroups.indexOf(group), 1);
    },
  },
  components: {
    draggable,
    formLoader,
    formSubmit,
    modal,
  },
  mixins: [accountingMixin],
  computed: {
    crossSellUrl: function () {
      return "/api/" + this.$route.params.userSlug + "/menu/cross-sells";
    },
  },
};
</script>
